import { LineString } from "ol/geom";
import { fromLonLat } from "ol/proj";
import { useEffect, useMemo } from "react";
import { RFeature, RLayerVector, RStyle } from "rlayers";
import { RStroke } from "rlayers/style";
import { useLayerManager } from "./LayerManager";
import { LeafletPolyline } from '../leaflet/LeafletPolyline';
import { useMapPaths } from "../../reducers/mapPathSlice";
import { useTranslation } from "react-i18next";

const OLPath = ({ path, zIndex }) => {
    const { t } = useTranslation();
    const { registerLayer, unregisterLayer, isVisible, getOpacity } = useLayerManager();
    const id = 'path_' + path.id;

    useEffect(() => {
        registerLayer(id, path.name, path.group ?? t('path', { count: 100 }), 'Path', path.visible, 1);
        return () => unregisterLayer(id);
    }, [id, path, registerLayer, unregisterLayer, t]);

    const line = useMemo(() => new LineString(path.path.map(lonlat => fromLonLat(lonlat))), [path.path]);
    const visible = isVisible(id);
    const opacity = getOpacity(id);

    return <RLayerVector properties={{ title: path.name, group: path.group }} visible={visible} opacity={opacity} zIndex={zIndex}>
        <RStyle.RStyle>
            <RStroke color={path.color} width={path.width}></RStroke>
        </RStyle.RStyle>
        <RFeature properties={{ altitudeMode: 'clampToGround' }} geometry={line}></RFeature>
    </RLayerVector>;
};
const LeafletPath = ({ path, zIndex }) => {
    const line = useMemo(() => path.path.map(([lon, lat]) => [lat, lon]), [path.path]);
    return <LeafletPolyline positions={line} pathOptions={{ color: path.color, weight: path.width, zIndex }}></LeafletPolyline>;
};

export const PathLayers = ({ mode, zIndex }) => {
    const paths = useMapPaths();

    switch (mode) {
        case 'ol':
            return paths.map(p => <OLPath key={p.id} path={p} zIndex={zIndex}></OLPath>);
        case 'leaflet':
            return paths.map(p => <LeafletPath key={p.id} path={p} zIndex={zIndex}></LeafletPath>);
        default:
            throw new Error('Unknown mode ' + mode);
    }
};
